import type { MainPropertyType, XMLPropertyResult } from '@aloft/toolkit-shared';

import { extractAdditionalFeatureMetadata } from './extractAdditionalFeatureLabels.ts';
import { extractPropertyResult } from './extractPropertyResult.ts';
import { extractSubjectAddress } from './extractSubjectAddress.ts';
import { extractSubjectMLS } from './extractSubjectMLS.ts';
import { extractSubjectPropertyType } from './extractSubjectPropertyType.ts';
import type { AdditionalFeatureLabels } from './types.ts';

export const extractSubjectResult = (
  doc: Document,
): {
  subject: XMLPropertyResult;
  featureLabels: AdditionalFeatureLabels;
  formType: string;
  defaultPropertyType: MainPropertyType;
} => {
  const comparableSales = [...doc.getElementsByTagName('COMPARABLE_SALE')];

  const subjectSale = comparableSales[0];
  if (!subjectSale) throw new Error('Missing subject');

  const featureMetadata = extractAdditionalFeatureMetadata(subjectSale);
  const { propertyType: defaultPropertyType, formType } = extractSubjectPropertyType(doc);

  const subjectComp = extractPropertyResult(
    subjectSale,
    { t: 'subject', features: featureMetadata },
    defaultPropertyType,
  );

  const { mls, mlsListingID } = extractSubjectMLS(doc);
  const address = extractSubjectAddress(doc);
  const subject = {
    ...subjectComp,
    mls,
    mlsListingID,
    address: address ?? subjectComp.address,
  };

  return {
    subject,
    featureLabels: {
      featureLabel1: featureMetadata.feature1.label,
      featureLabel2: featureMetadata.feature2.label,
      featureLabel3: featureMetadata.feature3.label,
    },
    formType,
    defaultPropertyType,
  };
};
